//@flow

export type Response = {
  req:{
    url:string,
    path:string,
    headers:{[string]:string},
    method:string,
    _data:Object,
  },
  headers:Object,
  body:any,
  ok:boolean,
  status:number,
};

export default class APIResponseReader {
  response:?Response;
  errorType:?string;

  constructor(response:?$Shape<Response>, errorType?:?string) {
    this.response = response;
    this.errorType = errorType;
  }

  getTrackingUrl():?string {
    return this.response && this.response.req.url;
  }

  getRequestMethod():?string {
    return this.response && this.response.req.method;
  }

  getRequestData():Object {
    return (this.response && this.response.req._data) || {};
  }

  getResponseBody():Object {
    return (this.response && this.response.body && this.response.body.body) || {};
  }

  getErrors():string[] {
    // pull errors from the response and ensure that it is an array
    let errors = (this.response && this.response.body && this.response.body.errors) || [];
    errors = [].concat(errors);

    // pull out the messages into an array of strings or return the object if no message
    return errors.map((err) => err.message || err);
  }

  getErrorType():?string {
    return this.errorType;
  }
}
